import { normalizeFormDefinition } from '@dec/shared';
import { type AxiosPromise, type AxiosRequestConfig } from 'axios';
import { type RefetchOptions } from 'axios-hooks';

import { useGetApplication } from '../../../hooks';
import { type FormDefinitionResponse } from '../models/definition.types';
const baseUrl = '/formdefinition';
export const useGetFormDefinition: (
  version: string,
  onLoad?: boolean
) => {
  loading: boolean;
  data: FormDefinitionResponse;
  error: any;
  response: any;

  execute: (
    config?: AxiosRequestConfig,
    options?: RefetchOptions
  ) => AxiosPromise<FormDefinitionResponse>;
} = (version: string, onLoad = true) => {
  const [{ data, loading, error, response }, execute] = useGetApplication<FormDefinitionResponse>(
    {
      url: `${baseUrl}/${version}`,
      params: {}
    },
    onLoad
  );

  return { loading, data: normalizeFormDefinition(data), error, response, execute } as any;
};
